import Seo from "../components/Seo";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Container } from "../components/Container";
import { useI18n } from "../i18n/LanguageProvider";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Link } from "react-router-dom";

export default function Support() {
  const { t, locale } = useI18n();
  const data = t("legal.support");

  return (
    <div className="bg-white" data-testid="support-page">
      <Seo titleKey="meta.support.title" descKey="meta.support.description" path="/support" pageType="support" breadcrumbs={[{ name: t("footer.links.home"), path: "" }, { name: data.title, path: "/support" }]} />
      <Header />
      <Breadcrumbs items={[{ name: t("footer.links.home"), to: `/${locale}` }, { name: data.title }]} />
      <main className="pt-10 md:pt-14">
        <Container>
          <div className="max-w-3xl">
            <Reveal>
              <h1 className="text-4xl font-semibold leading-tight tracking-tighter text-black sm:text-5xl lg:text-6xl">
                {data.title}
              </h1>
            </Reveal>
            <Reveal delay={0.08}>
              <p className="mt-6 text-lg leading-relaxed text-black/55">{data.intro}</p>
            </Reveal>
          </div>

          <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-black/[0.08] bg-black/[0.06] md:grid-cols-2">
            {data.faqs.map((f, i) => (
              <Reveal key={i} delay={i * 0.05} className="bg-white">
                <div className="h-full p-8 md:p-10">
                  <h3 className="text-lg font-semibold tracking-tight text-black">{f.q}</h3>
                  <p className="mt-2 text-base leading-relaxed text-black/55">{f.a}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-16 flex flex-col items-start gap-2 border-t border-black/5 pt-10 pb-4 text-lg text-black/60">
              <span>{data.contactLine}</span>
              <a
                href="mailto:support@centauros.app"
                data-testid="support-contact-email"
                className="font-medium text-black underline decoration-green decoration-2 underline-offset-4 transition-colors hover:text-green"
              >
                support@centauros.app
              </a>
              <Link
                to={`/${locale}/contact`}
                className="mt-3 text-sm font-medium text-green hover:underline"
                data-testid="support-to-contact"
              >
                {t("nav.contact")} →
              </Link>
            </div>
          </Reveal>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
